import useWhitelabelMode, {
  WhitelabelMode,
} from "../../hooks/useWhitelabelMode";
import { useStyles } from "./styles";
import BaseLogo from "../BaseLogo";

const SidebarLogo = () => {
  const classes = useStyles();
  const [whitelabelMode, logoURL] = useWhitelabelMode();
  const VARIANT = "powered-by-sidebar";

  if (
    whitelabelMode === WhitelabelMode.CUSTOM_EVENT_BRANDING_LOGO ||
    whitelabelMode === WhitelabelMode.CUSTOM_EVENT_COMPANY_LOGO ||
    whitelabelMode === WhitelabelMode.CUSTOM_COMPANY_LOGO
  ) {
    return (
      <BaseLogo
        avatarLogoURL={logoURL}
        logoVariant={VARIANT}
        avatarClass={classes.avatar}
      />
    );
  }

  return <BaseLogo />;
};

export default SidebarLogo;
